<template>
  <div :id="id" :class="className" :style="{height:height,width:width}" />
</template>

<script>

import * as echarts from 'echarts'
import resize from '@/utils/mixins/resize'

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    goodsBrokenLine: {
      type: null,
      default: ''
    }
  },
  data() {
    return {
      chart: null,
      options: {
        backgroundColor: '#fff',
        width: '90%',
        title: {
          show: false,
          text: '同比/环比',
          top: '20',
          textStyle: {
            color: '#fff',
            fontSize: '22'
          },
          subtextStyle: {
            color: '#90979c',
            fontSize: '16'
          }
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(params, ticket, callback) {
            let tooltip = '<div>'
            if (params.length > 0) {
              tooltip += `<p>${params[0].name} </p><p>${params[0].marker} ${params[0].seriesName} ${params[0].data.num}, ${params[0].value}%</p>`
              if (params[1]) {
                tooltip += `<p>${params[1].marker} ${params[1].seriesName} ${params[1].data.num}, ${params[1].value}%</p>`
              }
            }
            tooltip += '</div>'
            return tooltip
          },
          axisPointer: {
            lineStyle: {
            },
            textStyle: {
              color: '#fff'
            }
          }
        },
        grid: {
          left: '5%',
          right: '5%',
          borderWidth: 0,
          top: 40,
          bottom: 40,
          textStyle: {
            color: '#fff'
          }
        },
        // legend: {
        //   // x: '5%',
        //   left: 'center',
        //   top: '5%',
        //   itemGap: 50,
        //   textStyle: {
        //     color: '#90979c'
        //   },
        //   data: ['同比', '环比']
        // },
        calculable: true,
        xAxis: [{
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#90979c'
            }
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitArea: {
            show: false
          },
          axisLabel: {
            interval: 0
          },
          data: []
        }],
        yAxis: [{
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              color: '#eeeeee'
            }
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#90979c'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0,
            formatter: '{value}%'
          },
          splitArea: {
            show: false
          }
        }],
        // dataZoom: [
        //   {
        //     show: true,
        //     height: 10,
        //     xAxisIndex: [
        //       0
        //     ],
        //     bottom: 5,
        //     startValue: 0,
        //     endValue: 16,
        //     handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
        //     handleSize: '110%',
        //     handleStyle: {
        //       color: '#d3dee5'
        //     },
        //     textStyle: {
        //       color: '#fff'
        //     },
        //     borderColor: '#90979c'
        //   },
        //   {
        //     type: 'inside',
        //     show: true,
        //     height: 15,
        //     start: 1,
        //     end: 35,
        //     zoomOnMouseWheel: false
        //   }
        // ],
        series: [
          {
            name: '同比',
            type: 'line',
            symbolSize: 10,
            symbol: 'emptyCircle',
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: 'rgba(253,180,79,0)' // 0% 处的颜色
                }, {
                  offset: 1, color: 'rgba(253,180,79,0.3)' // 100% 处的颜色
                }],
                global: false // 缺省为 false
              }
            },
            itemStyle: {
              normal: {
                color: '#FDB44F',
                barBorderRadius: 0,
                label: {
                  show: true,
                  position: 'top',
                  formatter(p) {
                    return p.value + '%'
                  }
                }
              }
            },
            data: []
          },
          {
            name: '环比',
            type: 'line',
            symbolSize: 10,
            symbol: 'emptyCircle',
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: 'rgba(163,136,227,0)' // 0% 处的颜色
                }, {
                  offset: 1, color: 'rgba(163,136,227,0.3)' // 100% 处的颜色
                }],
                global: false // 缺省为 false
              }
            },
            itemStyle: {
              normal: {
                color: '#886CE6',
                barBorderRadius: 0,
                label: {
                  show: true,
                  position: 'top',
                  formatter(p) {
                    return p.value + '%'
                  }
                }
              }
            },
            data: []
          }
        ]
      }
    }
  },
  watch: {
    goodsBrokenLine(value) {
      this.goodsBrokenLine = value
      this.initChart()
    }
  },
  mounted() {
    this.chart = echarts.init(document.getElementById(this.id))
    this.initChart()
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      const vm = this
      // 未获取数据前，显示loading加载动画
      if (vm.goodsBrokenLine == null || vm.goodsBrokenLine === '') {
        vm.chart.showLoading()
      } else {
        vm.chart.hideLoading()
        const { list } = this.goodsBrokenLine
        const options = vm.options
        // 时间
        const timeLine = Object.keys(list).map(i => {
          return {
            name: 'dataName',
            value: i,
            ...list[i]
          }
        })
        // 同比
        const nowDateThan = Object.values(list).map(i => {
          return {
            value: i.previous || 0,
            num: i.tongbi,
            ...i
          }
        })
        // 环比
        const oldDateThan = Object.values(list).map(i => {
          return {
            value: i.hb,
            num: i.huanbi,
            ...i
          }
        })
        options.xAxis[0].data = timeLine
        options.series[0].data = nowDateThan
        options.series[1].data = oldDateThan
        vm.chart.setOption(options, true)
      }
    }
  }
}
</script>
